// exp_PORTFOLIO-58018_file
export enum VrPresets {
    Small = 'SMALL',
    Medium = 'MEDIUM',
    Large = 'LARGE',
    Custom = 'CUSTOM',
}

export const PRESETS_CONFIG: Record<VrPresets, { responses: number; budget: number }> = {
    [VrPresets.Small]: { responses: 10, budget: 5000 },
    [VrPresets.Medium]: { responses: 20, budget: 10000 },
    [VrPresets.Large]: { responses: 50, budget: 25000 },
    [VrPresets.Custom]: { responses: 0, budget: 0 },
};

export const ONE_RESPONSE_PRICE = 500;
export const RESPONSES_INPUT_STEP = 5;
export const MIN_RESPONSES = 10;
export const MIN_BUDGET = 5000;
export const REQUIREMENTS_MAX_LENGTH = 255;

export interface VrCampaignErrors {
    responses: boolean;
    budget: boolean;
    areas: boolean;
    requirements: boolean;
}

interface VrCampaignValidationInput {
    responses: number;
    budget: number;
    areas: number[];
    requirements: string;
}

export const validateVrCampaign = ({
    responses,
    budget,
    areas,
    requirements,
}: VrCampaignValidationInput): VrCampaignErrors => ({
    responses: responses < MIN_RESPONSES,
    budget: budget < MIN_BUDGET,
    areas: areas.length === 0,
    requirements: requirements.length > REQUIREMENTS_MAX_LENGTH,
});

export const hasVrCampaignErrors = (errors: VrCampaignErrors): boolean => Object.values(errors).some(Boolean);
